import { prefersReducedMotion } from "@js/parts/prefersReducedMotion";

export default function logoCarousel() {
  return {
    offset: 0,
    speed: 50, // pixels per second
    contentWidth: 0, // width of one full set of logos
    lastTimestamp: 0,

    init() {
      // Wait until DOM is “hydrated” so that $refs.slider is rendered
      this.$nextTick(() => {
        // The slider has two direct children: [0] = first set, [1] = second set
        this.contentWidth = this.$refs.slider.children[0].offsetWidth;

        if (prefersReducedMotion()) {
          this.offset = 0;
          return;
        }

        // Start the animation loop:
        this.lastTimestamp = performance.now();
        requestAnimationFrame(this.animate.bind(this));
      });
    },

    animate(ts) {
      // Compute time difference (in milliseconds)
      const delta = ts - this.lastTimestamp;
      // How many pixels to move this frame:
      const movement = (this.speed * delta) / 1000;
      this.offset = (this.offset + movement) % this.contentWidth;
      this.lastTimestamp = ts;

      // Manually set transform on the slider
      this.$refs.slider.style.transform = `translateX(-${this.offset.toFixed(
        2
      )}px)`;

      requestAnimationFrame(this.animate.bind(this));
    },
  };
}
